import { generateServiceId } from "@core/domains/identity";

export const CALORIE_GRID_SERVICE = {
  ID: generateServiceId("calorie_grid"),
  LABEL: "calorie-grid",
} as const;
